export default __webpack_public_path__ + "6608e1958a305e05d5d27c2201aaf6af.png";